<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ Формат Mobile Benefit Banner</div>
    <div class="markup__h markup__h_3">Mobile Benefit Banner включает в себя:
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Перетяжку в верхней части формата, которая содержит заголовок и логотип</li>
      <li>Текстовый блок на фоновом изображении по центру креатива, фото амбассадора, значок свайпа слайдов</li>
      <li>Кнопку для перехода на сайт в нижней части креатива</li>
      <li>Юридическую информацию (опционально)</li>
    </ul>
    <div class="attention attention_info">
      <p>Данный формат предполагает, что у бренда есть один или несколько амбассадоров и действующие права на использование их выражений в целях промотирования.</p>
    </div>

    <router-link to="/mobile/benefitBanner" target="_blank" class="link">Демо формата</router-link>
    <br><br>

    <div class="markup__h markup__h_2">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>
        <div class="markup__h markup__h_3">
          <strong>Изображения продукта</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: PSD / FIGMA / AI / PNG / JPG</li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Логотип:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: PNG</li>
          <li>Прозрачный фон</li>
          <li>Соотношение сторон: рекомендуется 1:1</li>
          <li>Размеры: ширина от 200px</li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Шрифты</strong>
        </div>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Brandbook</strong> (в том числе пожелания по цветовому оформлению)
        </div>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Фото амбассадоров</strong>
        </div>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Тексты цитат</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Не более 200 символов</li>
          <li>Рекомендация: если слайдов предполагается несколько, желательно сопроводительные тексты делать примерно одной длины, чтобы формат выглядел эстетично.</li>
        </ul>
      </li>
    </ul>
    <marked-zone-atention></marked-zone-atention>
  </div>
</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'mobileBenefitBanner',
  components: {
    markedZoneAtention,
  },
  data() {
    return {
      is_shown_preview: false,
    };
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
